<template>
  <div class="content-auth px-4">
    <div class="left-side">
      <SideBarConnect />
    </div>
    <div class="right-side">
      <div class="right-side-inner">
        <router-view />
        <FooterConnect />
      </div>
    </div>
  </div>
</template>

<script>
  import SideBarConnect from "@/components/SideBarConnect.vue";
  import FooterConnect from "@/components/FooterConnect.vue";

  export default {
    name: "ProductListPage",
    components: {
      SideBarConnect,
      FooterConnect,
    },
  };
</script>
<style scoped>
  .content-auth {
    padding: 30px;
    background-color: #f5f6f9;
    align-items: center;
  }

  @media (max-width: 991.98px) {
    .left-side {
      display: none !important;
    }
    .right-side {
      width: 100% !important;
    }
  }
</style>
